<div class="main-container">
  <app-landing-nav></app-landing-nav>
  <router-outlet></router-outlet>
  <app-footer type="main" (openDemo)="openDemo()" />
</div>
<app-demo-modal></app-demo-modal>
<app-cookie-consent></app-cookie-consent>
